// extracted by mini-css-extract-plugin
export default {"productDescription":"aba-z","featuredDescription":"bba-z","description":"cba-z","more":"dba-z","descriptionSku":"eba-z"};